/* eslint-disable @typescript-eslint/no-inferrable-types */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/naming-convention */
/**
 * This file was auto-generated (npm run generate:api).
 * Do not make direct changes to the file.
 */
import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { components, paths } from 'interfaces/api/customers';
import { del, get, patch, post, put } from 'shared/utils/api';
import { RequestConfig } from 'shared/utils/api/request';
import { objectToQueryParams } from 'utils/format';
import { identity } from 'utils/identity';

/**
 * `/customers/{lid}/subscriptionkey`: This method will return columbus agreement number and OSSi subscriber number for that LID
 * @param lid  No description
 * @param requestConfig Any additional properties to be added to the request
 */
export const fetchSubscriptionkeyByLid = (
  lid: string,
  requestConfig: RequestConfig | null = null,
): Promise<
  components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.ColumbusSubscriptionKey']
> =>
  get({
    url: `${lid}/subscriptionkey`,
    apiSegment: 'customers',
    requireAuth: true,
    ...(requestConfig || {}),
  });

/**
 * `/customers/{lid}/subscriptionkey`: This method will return columbus agreement number and OSSi subscriber number for that LID
 * @param lid  No description
 * @param requestConfig Any additional properties to be added to the request
 * @param queryConfig  Optional configuration object for React Query
 */
export const useSubscriptionkeyByLid = <
  TOut = components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.ColumbusSubscriptionKey'],
>(
  lid: string,
  requestConfig: RequestConfig | null = null,
  queryConfig: UseQueryOptions<
    components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.ColumbusSubscriptionKey'],
    AxiosError<any>,
    TOut,
    any[]
  > | null = null,
) =>
  useQuery(
    ['/customers/{lid}/subscriptionkey', identity.userId, lid],
    () => fetchSubscriptionkeyByLid(lid, requestConfig),
    queryConfig || {},
  );

/**
 * `/customers/service/configuration`: Update a Customer Service Configuration for instance Data refresh time
 * @param requestConfig Any additional properties to be added to the request
 */
export const submitServiceConfiguration = (
  data: components['schemas']['Nuuday.NextGen.Customers.Contracts.Configurations.ServiceConfiguration'],
  requestConfig: RequestConfig | null = null,
): Promise<any> =>
  post({
    url: `service/configuration`,
    apiSegment: 'customers',
    data,
    requireAuth: true,
    ...(requestConfig || {}),
  });

/**
 * `/customers/my`: Gets all customers associated to an authenticated user.
 * @param requestConfig Any additional properties to be added to the request
 */
export const fetchMyCustomers = (
  requestConfig: RequestConfig | null = null,
): Promise<components['schemas']['Nuuday.NextGen.Customers.Contracts.Customer'][]> =>
  get({
    url: `my`,
    apiSegment: 'customers',
    requireAuth: true,
    ...(requestConfig || {}),
  });

/**
 * `/customers/my`: Gets all customers associated to an authenticated user.
 * @param requestConfig Any additional properties to be added to the request
 * @param queryConfig  Optional configuration object for React Query
 */
export const useMyCustomers = <
  TOut = components['schemas']['Nuuday.NextGen.Customers.Contracts.Customer'][],
>(
  requestConfig: RequestConfig | null = null,
  queryConfig: UseQueryOptions<
    components['schemas']['Nuuday.NextGen.Customers.Contracts.Customer'][],
    AxiosError<any>,
    TOut,
    any[]
  > | null = null,
) =>
  useQuery(
    ['/customers/my', identity.userId],
    () => fetchMyCustomers(requestConfig),
    queryConfig || {},
  );

/**
 * `/customers/users/{userId}/customers`: Gets all customers associated to a user.
 * @param userId  No description
 * @param requestConfig Any additional properties to be added to the request
 */
export const fetchUsersCustomersByUserId = (
  userId: number,
  requestConfig: RequestConfig | null = null,
): Promise<components['schemas']['Nuuday.NextGen.Customers.Contracts.Customer'][]> =>
  get({
    url: `users/${userId}/customers`,
    apiSegment: 'customers',
    requireAuth: true,
    ...(requestConfig || {}),
  });

/**
 * `/customers/users/{userId}/customers`: Gets all customers associated to a user.
 * @param userId  No description
 * @param requestConfig Any additional properties to be added to the request
 * @param queryConfig  Optional configuration object for React Query
 */
export const useUsersCustomersByUserId = <
  TOut = components['schemas']['Nuuday.NextGen.Customers.Contracts.Customer'][],
>(
  userId: number,
  requestConfig: RequestConfig | null = null,
  queryConfig: UseQueryOptions<
    components['schemas']['Nuuday.NextGen.Customers.Contracts.Customer'][],
    AxiosError<any>,
    TOut,
    any[]
  > | null = null,
) =>
  useQuery(
    ['/customers/users/{userId}/customers', identity.userId, userId],
    () => fetchUsersCustomersByUserId(userId, requestConfig),
    queryConfig || {},
  );

/**
 * `/customers/{linkitId}`: Gets all customers associated to a supplied linkit-id.
 * @param linkitId  No description
 * @param requestConfig Any additional properties to be added to the request
 */
export const fetchCustomersByLinkitId = (
  linkitId: string,
  requestConfig: RequestConfig | null = null,
): Promise<components['schemas']['Nuuday.NextGen.Customers.Contracts.Customer']> =>
  get({
    url: `${linkitId}`,
    apiSegment: 'customers',
    requireAuth: true,
    ...(requestConfig || {}),
  });

/**
 * `/customers/{linkitId}`: Gets all customers associated to a supplied linkit-id.
 * @param linkitId  No description
 * @param requestConfig Any additional properties to be added to the request
 * @param queryConfig  Optional configuration object for React Query
 */
export const useCustomersByLinkitId = <
  TOut = components['schemas']['Nuuday.NextGen.Customers.Contracts.Customer'],
>(
  linkitId: string,
  requestConfig: RequestConfig | null = null,
  queryConfig: UseQueryOptions<
    components['schemas']['Nuuday.NextGen.Customers.Contracts.Customer'],
    AxiosError<any>,
    TOut,
    any[]
  > | null = null,
) =>
  useQuery(
    ['/customers/{linkitId}', identity.userId, linkitId],
    () => fetchCustomersByLinkitId(linkitId, requestConfig),
    queryConfig || {},
  );

/**
 * `/customers/search/address`: Gets all customers associated to a supplied Address.
 * @param requestConfig Any additional properties to be added to the request
 */
export const submitSearchAddress = (
  data: components['schemas']['Nuuday.NextGen.Customers.Contracts.AddressQuery'],
  requestConfig: RequestConfig | null = null,
): Promise<components['schemas']['Nuuday.NextGen.Customers.Contracts.Customer'][]> =>
  post({
    url: `search/address`,
    apiSegment: 'customers',
    data,
    requireAuth: true,
    ...(requestConfig || {}),
  });

/**
 * `/customers/search`: No summary available
 * @param Identifier  No description
 * @param Type  No description
 * @param requestConfig Any additional properties to be added to the request
 */
export const fetchSearch = (
  queryParameters: {
    Identifier?: string;
    Type?: components['schemas']['Nuuday.NextGen.Customers.Contracts.CustomerQueryIdentifierType'];
  } = {},
  requestConfig: RequestConfig | null = null,
): Promise<components['schemas']['Nuuday.NextGen.Customers.Contracts.Customer'][]> =>
  get({
    url: `search${objectToQueryParams(queryParameters)}`,
    apiSegment: 'customers',
    requireAuth: true,
    ...(requestConfig || {}),
  });

/**
 * `/customers/search`: No summary available
 * @param Identifier  No description
 * @param Type  No description
 * @param requestConfig Any additional properties to be added to the request
 * @param queryConfig  Optional configuration object for React Query
 */
export const useSearch = <
  TOut = components['schemas']['Nuuday.NextGen.Customers.Contracts.Customer'][],
>(
  queryParameters: {
    Identifier?: string;
    Type?: components['schemas']['Nuuday.NextGen.Customers.Contracts.CustomerQueryIdentifierType'];
  } = {},
  requestConfig: RequestConfig | null = null,
  queryConfig: UseQueryOptions<
    components['schemas']['Nuuday.NextGen.Customers.Contracts.Customer'][],
    AxiosError<any>,
    TOut,
    any[]
  > | null = null,
) =>
  useQuery(
    ['/customers/search', identity.userId, queryParameters],
    () => fetchSearch(queryParameters, requestConfig),
    queryConfig || {},
  );

/**
 * `/customers/trysearch`: No summary available
 * @param Identifier  No description
 * @param Type  No description
 * @param requestConfig Any additional properties to be added to the request
 */
export const fetchTrysearch = (
  queryParameters: {
    Identifier?: string;
    Type?: components['schemas']['Nuuday.NextGen.Customers.Contracts.CustomerQueryIdentifierType'];
  } = {},
  requestConfig: RequestConfig | null = null,
): Promise<components['schemas']['Nuuday.NextGen.Customers.Contracts.Customer'][]> =>
  get({
    url: `trysearch${objectToQueryParams(queryParameters)}`,
    apiSegment: 'customers',
    requireAuth: true,
    ...(requestConfig || {}),
  });

/**
 * `/customers/trysearch`: No summary available
 * @param Identifier  No description
 * @param Type  No description
 * @param requestConfig Any additional properties to be added to the request
 * @param queryConfig  Optional configuration object for React Query
 */
export const useTrysearch = <
  TOut = components['schemas']['Nuuday.NextGen.Customers.Contracts.Customer'][],
>(
  queryParameters: {
    Identifier?: string;
    Type?: components['schemas']['Nuuday.NextGen.Customers.Contracts.CustomerQueryIdentifierType'];
  } = {},
  requestConfig: RequestConfig | null = null,
  queryConfig: UseQueryOptions<
    components['schemas']['Nuuday.NextGen.Customers.Contracts.Customer'][],
    AxiosError<any>,
    TOut,
    any[]
  > | null = null,
) =>
  useQuery(
    ['/customers/trysearch', identity.userId, queryParameters],
    () => fetchTrysearch(queryParameters, requestConfig),
    queryConfig || {},
  );

/**
 * `/customers/search/{identifier}/subscription`: Gets customer associated to a subscription identifier.
 * @param identifier  No description
 * @param EnablePackageExpansion  No description
 * @param IncludeRootPackageWhenPackageExpansionIsEnabled  No description
 * @param EnableBackwardsCompatibility  No description
 * @param DataLimitationPolicy  No description
 * @param DataStructurePolicy  No description
 * @param DataFilteringPolicy  No description
 * @param requestConfig Any additional properties to be added to the request
 */
export const fetchSearchSubscriptionByIdentifier = (
  identifier: string,
  queryParameters: {
    EnablePackageExpansion?: boolean;
    IncludeRootPackageWhenPackageExpansionIsEnabled?: boolean;
    EnableBackwardsCompatibility?: boolean;
    DataLimitationPolicy?: components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.DataLimitationPolicy'];
    DataStructurePolicy?: components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.DataStructurePolicy'];
    DataFilteringPolicy?: components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.DataFilteringPolicy'][];
  } = {},
  requestConfig: RequestConfig | null = null,
): Promise<components['schemas']['Nuuday.NextGen.Customers.Contracts.Customer']> =>
  get({
    url: `search/${identifier}/subscription${objectToQueryParams(queryParameters)}`,
    apiSegment: 'customers',
    requireAuth: true,
    ...(requestConfig || {}),
  });

/**
 * `/customers/search/{identifier}/subscription`: Gets customer associated to a subscription identifier.
 * @param identifier  No description
 * @param EnablePackageExpansion  No description
 * @param IncludeRootPackageWhenPackageExpansionIsEnabled  No description
 * @param EnableBackwardsCompatibility  No description
 * @param DataLimitationPolicy  No description
 * @param DataStructurePolicy  No description
 * @param DataFilteringPolicy  No description
 * @param requestConfig Any additional properties to be added to the request
 * @param queryConfig  Optional configuration object for React Query
 */
export const useSearchSubscriptionByIdentifier = <
  TOut = components['schemas']['Nuuday.NextGen.Customers.Contracts.Customer'],
>(
  identifier: string,
  queryParameters: {
    EnablePackageExpansion?: boolean;
    IncludeRootPackageWhenPackageExpansionIsEnabled?: boolean;
    EnableBackwardsCompatibility?: boolean;
    DataLimitationPolicy?: components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.DataLimitationPolicy'];
    DataStructurePolicy?: components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.DataStructurePolicy'];
    DataFilteringPolicy?: components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.DataFilteringPolicy'][];
  } = {},
  requestConfig: RequestConfig | null = null,
  queryConfig: UseQueryOptions<
    components['schemas']['Nuuday.NextGen.Customers.Contracts.Customer'],
    AxiosError<any>,
    TOut,
    any[]
  > | null = null,
) =>
  useQuery(
    ['/customers/search/{identifier}/subscription', identity.userId, identifier, queryParameters],
    () => fetchSearchSubscriptionByIdentifier(identifier, queryParameters, requestConfig),
    queryConfig || {},
  );

/**
 * `/customers/trysearch/{identifier}/subscription`: Gets customer associated to a subscription identifier.
 * @param identifier  No description
 * @param EnablePackageExpansion  No description
 * @param IncludeRootPackageWhenPackageExpansionIsEnabled  No description
 * @param EnableBackwardsCompatibility  No description
 * @param DataLimitationPolicy  No description
 * @param DataStructurePolicy  No description
 * @param DataFilteringPolicy  No description
 * @param requestConfig Any additional properties to be added to the request
 */
export const fetchTrysearchSubscriptionByIdentifier = (
  identifier: string,
  queryParameters: {
    EnablePackageExpansion?: boolean;
    IncludeRootPackageWhenPackageExpansionIsEnabled?: boolean;
    EnableBackwardsCompatibility?: boolean;
    DataLimitationPolicy?: components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.DataLimitationPolicy'];
    DataStructurePolicy?: components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.DataStructurePolicy'];
    DataFilteringPolicy?: components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.DataFilteringPolicy'][];
  } = {},
  requestConfig: RequestConfig | null = null,
): Promise<components['schemas']['Nuuday.NextGen.Customers.Contracts.Customer']> =>
  get({
    url: `trysearch/${identifier}/subscription${objectToQueryParams(queryParameters)}`,
    apiSegment: 'customers',
    requireAuth: true,
    ...(requestConfig || {}),
  });

/**
 * `/customers/trysearch/{identifier}/subscription`: Gets customer associated to a subscription identifier.
 * @param identifier  No description
 * @param EnablePackageExpansion  No description
 * @param IncludeRootPackageWhenPackageExpansionIsEnabled  No description
 * @param EnableBackwardsCompatibility  No description
 * @param DataLimitationPolicy  No description
 * @param DataStructurePolicy  No description
 * @param DataFilteringPolicy  No description
 * @param requestConfig Any additional properties to be added to the request
 * @param queryConfig  Optional configuration object for React Query
 */
export const useTrysearchSubscriptionByIdentifier = <
  TOut = components['schemas']['Nuuday.NextGen.Customers.Contracts.Customer'],
>(
  identifier: string,
  queryParameters: {
    EnablePackageExpansion?: boolean;
    IncludeRootPackageWhenPackageExpansionIsEnabled?: boolean;
    EnableBackwardsCompatibility?: boolean;
    DataLimitationPolicy?: components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.DataLimitationPolicy'];
    DataStructurePolicy?: components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.DataStructurePolicy'];
    DataFilteringPolicy?: components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.DataFilteringPolicy'][];
  } = {},
  requestConfig: RequestConfig | null = null,
  queryConfig: UseQueryOptions<
    components['schemas']['Nuuday.NextGen.Customers.Contracts.Customer'],
    AxiosError<any>,
    TOut,
    any[]
  > | null = null,
) =>
  useQuery(
    [
      '/customers/trysearch/{identifier}/subscription',
      identity.userId,
      identifier,
      queryParameters,
    ],
    () => fetchTrysearchSubscriptionByIdentifier(identifier, queryParameters, requestConfig),
    queryConfig || {},
  );

/**
 * `/customers/{id}/communication/generalemail`: Updates the general communication email for all customers associated to the supplied linkit-id.
 * @param id  Updates all customers correlated to id.
 * @param data  EmailAddress address to update
 * @param requestConfig Any additional properties to be added to the request
 */
export const submitCommunicationGeneralemailById = (
  id: string,
  data: string,
  requestConfig: RequestConfig | null = null,
): Promise<
  components['schemas']['Nuuday.NextGen.Foundation.Transactions.DistributedTransaction']
> =>
  put({
    url: `${id}/communication/generalemail`,
    apiSegment: 'customers',
    data,
    requireAuth: true,
    ...(requestConfig || {}),
  });

/**
 * `/customers/{id}/youseepermissions/operational`: Updates the operational permission for email or sms on all customers associated to the supplied linkit-id.
 * @param id  Updates all customers correlated to id.
 * @param data  Operational permissions to update.
 * @param requestConfig Any additional properties to be added to the request
 */
export const submitYouseepermissionsOperationalById = (
  id: string,
  data: components['schemas']['Nuuday.NextGen.Customers.Contracts.Permission.UpdateOperationalPermissions'],
  requestConfig: RequestConfig | null = null,
): Promise<
  components['schemas']['Nuuday.NextGen.Foundation.Transactions.DistributedTransaction']
> =>
  put({
    url: `${id}/youseepermissions/operational`,
    apiSegment: 'customers',
    data,
    requireAuth: true,
    ...(requestConfig || {}),
  });

/**
 * `/customers/{id}/youseepermissions/marketing`: Updates the marketing permission for email on all customers associated to the supplied linkit-id.
 * @param id  Updates all customers correlated to id.
 * @param data  Marketing permissions to update.
 * @param requestConfig Any additional properties to be added to the request
 */
export const submitYouseepermissionsMarketingById = (
  id: string,
  data: components['schemas']['Nuuday.NextGen.Customers.Contracts.Permission.UpdateMarketingPermissions'],
  requestConfig: RequestConfig | null = null,
): Promise<
  components['schemas']['Nuuday.NextGen.Foundation.Transactions.DistributedTransaction']
> =>
  put({
    url: `${id}/youseepermissions/marketing`,
    apiSegment: 'customers',
    data,
    requireAuth: true,
    ...(requestConfig || {}),
  });

/**
 * `/customers/users/{userId}/expirelocaldata`: Expire the user->account relation.
 * Note! This is a broken concept that will be removed. Don't use!!
 * @param userId  Sentry persona id for user
 * @param requestConfig Any additional properties to be added to the request
 */
export const submitUsersExpirelocaldataByUserId = (
  userId: number,
  requestConfig: RequestConfig | null = null,
): Promise<any> =>
  post({
    url: `users/${userId}/expirelocaldata`,
    apiSegment: 'customers',
    requireAuth: true,
    ...(requestConfig || {}),
  });

/**
 * `/customers/my/subscriptions`: Gets all subscriptions associated to the authenticated user.
 * @param EnablePackageExpansion  No description
 * @param IncludeRootPackageWhenPackageExpansionIsEnabled  No description
 * @param EnableBackwardsCompatibility  No description
 * @param IncludeMigratedData Include products being migrated to Netcracker
 * @param DataLimitationPolicy  No description
 * @param DataStructurePolicy  No description
 * @param DataFilteringPolicy  No description
 * @param requestConfig Any additional properties to be added to the request
 */
export const fetchMySubscriptions = (
  queryParameters: {
    EnablePackageExpansion?: boolean;
    IncludeRootPackageWhenPackageExpansionIsEnabled?: boolean;
    EnableBackwardsCompatibility?: boolean;
    IncludeMigratedData?: boolean;
    DataLimitationPolicy?: components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.DataLimitationPolicy'];
    DataStructurePolicy?: components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.DataStructurePolicy'];
    DataFilteringPolicy?: components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.DataFilteringPolicy'][];
  } = {},
  requestConfig: RequestConfig | null = null,
): Promise<
  (components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.FullSubscription'] &
    components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.LimitedSubscription'] &
    components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.PartialSubscription'])[]
> =>
  get({
    url: `my/subscriptions${objectToQueryParams(queryParameters)}`,
    apiSegment: 'customers',
    requireAuth: true,
    ...(requestConfig || {}),
  });

/**
 * `/customers/my/subscriptions`: Gets all subscriptions associated to the authenticated user.
 * @param EnablePackageExpansion  No description
 * @param IncludeRootPackageWhenPackageExpansionIsEnabled  No description
 * @param EnableBackwardsCompatibility  No description
 * @param IncludeMigratedData Include products being migrated to Netcracker
 * @param DataLimitationPolicy  No description
 * @param DataStructurePolicy  No description
 * @param DataFilteringPolicy  No description
 * @param requestConfig Any additional properties to be added to the request
 * @param queryConfig  Optional configuration object for React Query
 */
export const useMySubscriptions = <
  TOut = (components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.FullSubscription'] &
    components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.LimitedSubscription'] &
    components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.PartialSubscription'] & {
      isFrozen: boolean;
      isMigrated: boolean;
    })[],
>(
  queryParameters: {
    EnablePackageExpansion?: boolean;
    IncludeRootPackageWhenPackageExpansionIsEnabled?: boolean;
    EnableBackwardsCompatibility?: boolean;
    IncludeMigratedData?: boolean;
    DataLimitationPolicy?: components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.DataLimitationPolicy'];
    DataStructurePolicy?: components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.DataStructurePolicy'];
    DataFilteringPolicy?: components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.DataFilteringPolicy'][];
  } = {},
  requestConfig: RequestConfig | null = null,
  queryConfig: UseQueryOptions<
    (components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.FullSubscription'] &
      components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.LimitedSubscription'] &
      components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.PartialSubscription'])[],
    AxiosError<any>,
    TOut,
    any[]
  > | null = null,
) =>
  useQuery(
    ['/customers/my/subscriptions', identity.userId, queryParameters],
    () => fetchMySubscriptions(queryParameters, requestConfig),
    queryConfig || {},
  );

/**
 * `/customers/users/{userId}/subscriptions`: Gets all subscriptions associated to the specified user
 * @param userId  No description
 * @param EnablePackageExpansion  No description
 * @param IncludeRootPackageWhenPackageExpansionIsEnabled  No description
 * @param EnableBackwardsCompatibility  No description
 * @param DataLimitationPolicy  No description
 * @param DataStructurePolicy  No description
 * @param DataFilteringPolicy  No description
 * @param requestConfig Any additional properties to be added to the request
 */
export const fetchUsersSubscriptionsByUserId = (
  userId: number,
  queryParameters: {
    EnablePackageExpansion?: boolean;
    IncludeRootPackageWhenPackageExpansionIsEnabled?: boolean;
    EnableBackwardsCompatibility?: boolean;
    DataLimitationPolicy?: components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.DataLimitationPolicy'];
    DataStructurePolicy?: components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.DataStructurePolicy'];
    DataFilteringPolicy?: components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.DataFilteringPolicy'][];
  } = {},
  requestConfig: RequestConfig | null = null,
): Promise<
  (components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.FullSubscription'] &
    components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.LimitedSubscription'] &
    components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.PartialSubscription'])[]
> =>
  get({
    url: `users/${userId}/subscriptions${objectToQueryParams(queryParameters)}`,
    apiSegment: 'customers',
    requireAuth: true,
    ...(requestConfig || {}),
  });

/**
 * `/customers/users/{userId}/subscriptions`: Gets all subscriptions associated to the specified user
 * @param userId  No description
 * @param EnablePackageExpansion  No description
 * @param IncludeRootPackageWhenPackageExpansionIsEnabled  No description
 * @param EnableBackwardsCompatibility  No description
 * @param DataLimitationPolicy  No description
 * @param DataStructurePolicy  No description
 * @param DataFilteringPolicy  No description
 * @param requestConfig Any additional properties to be added to the request
 * @param queryConfig  Optional configuration object for React Query
 */
export const useUsersSubscriptionsByUserId = <
  TOut = (components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.FullSubscription'] &
    components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.LimitedSubscription'] &
    components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.PartialSubscription'])[],
>(
  userId: number,
  queryParameters: {
    EnablePackageExpansion?: boolean;
    IncludeRootPackageWhenPackageExpansionIsEnabled?: boolean;
    EnableBackwardsCompatibility?: boolean;
    DataLimitationPolicy?: components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.DataLimitationPolicy'];
    DataStructurePolicy?: components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.DataStructurePolicy'];
    DataFilteringPolicy?: components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.DataFilteringPolicy'][];
  } = {},
  requestConfig: RequestConfig | null = null,
  queryConfig: UseQueryOptions<
    (components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.FullSubscription'] &
      components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.LimitedSubscription'] &
      components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.PartialSubscription'])[],
    AxiosError<any>,
    TOut,
    any[]
  > | null = null,
) =>
  useQuery(
    ['/customers/users/{userId}/subscriptions', identity.userId, userId, queryParameters],
    () => fetchUsersSubscriptionsByUserId(userId, queryParameters, requestConfig),
    queryConfig || {},
  );

/**
 * `/customers/subscriptions/{identifier}/linkit`: Gets all subscriptions associated to a linkit-id
 * @param identifier  No description
 * @param EnablePackageExpansion  No description
 * @param IncludeRootPackageWhenPackageExpansionIsEnabled  No description
 * @param EnableBackwardsCompatibility  No description
 * @param DataLimitationPolicy  No description
 * @param DataStructurePolicy  No description
 * @param DataFilteringPolicy  No description
 * @param requestConfig Any additional properties to be added to the request
 */
export const fetchSubscriptionsLinkitByIdentifier = (
  identifier: string,
  queryParameters: {
    EnablePackageExpansion?: boolean;
    IncludeRootPackageWhenPackageExpansionIsEnabled?: boolean;
    EnableBackwardsCompatibility?: boolean;
    DataLimitationPolicy?: components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.DataLimitationPolicy'];
    DataStructurePolicy?: components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.DataStructurePolicy'];
    DataFilteringPolicy?: components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.DataFilteringPolicy'][];
  } = {},
  requestConfig: RequestConfig | null = null,
): Promise<
  (components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.FullSubscription'] &
    components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.LimitedSubscription'] &
    components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.PartialSubscription'])[]
> =>
  get({
    url: `subscriptions/${identifier}/linkit${objectToQueryParams(queryParameters)}`,
    apiSegment: 'customers',
    requireAuth: true,
    ...(requestConfig || {}),
  });

/**
 * `/customers/subscriptions/{identifier}/linkit`: Gets all subscriptions associated to a linkit-id
 * @param identifier  No description
 * @param EnablePackageExpansion  No description
 * @param IncludeRootPackageWhenPackageExpansionIsEnabled  No description
 * @param EnableBackwardsCompatibility  No description
 * @param DataLimitationPolicy  No description
 * @param DataStructurePolicy  No description
 * @param DataFilteringPolicy  No description
 * @param requestConfig Any additional properties to be added to the request
 * @param queryConfig  Optional configuration object for React Query
 */
export const useSubscriptionsLinkitByIdentifier = <
  TOut = (components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.FullSubscription'] &
    components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.LimitedSubscription'] &
    components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.PartialSubscription'])[],
>(
  identifier: string,
  queryParameters: {
    EnablePackageExpansion?: boolean;
    IncludeRootPackageWhenPackageExpansionIsEnabled?: boolean;
    EnableBackwardsCompatibility?: boolean;
    DataLimitationPolicy?: components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.DataLimitationPolicy'];
    DataStructurePolicy?: components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.DataStructurePolicy'];
    DataFilteringPolicy?: components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.DataFilteringPolicy'][];
  } = {},
  requestConfig: RequestConfig | null = null,
  queryConfig: UseQueryOptions<
    (components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.FullSubscription'] &
      components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.LimitedSubscription'] &
      components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.PartialSubscription'])[],
    AxiosError<any>,
    TOut,
    any[]
  > | null = null,
) =>
  useQuery(
    ['/customers/subscriptions/{identifier}/linkit', identity.userId, identifier, queryParameters],
    () => fetchSubscriptionsLinkitByIdentifier(identifier, queryParameters, requestConfig),
    queryConfig || {},
  );

/**
 * `/customers/subscriptions/{identifier}/nameaddress`: Gets all subscriptions associated to a name-address-id
 * @param identifier  No description
 * @param EnablePackageExpansion  No description
 * @param IncludeRootPackageWhenPackageExpansionIsEnabled  No description
 * @param EnableBackwardsCompatibility  No description
 * @param DataLimitationPolicy  No description
 * @param DataStructurePolicy  No description
 * @param DataFilteringPolicy  No description
 * @param requestConfig Any additional properties to be added to the request
 */
export const fetchSubscriptionsNameaddressByIdentifier = (
  identifier: string,
  queryParameters: {
    EnablePackageExpansion?: boolean;
    IncludeRootPackageWhenPackageExpansionIsEnabled?: boolean;
    EnableBackwardsCompatibility?: boolean;
    DataLimitationPolicy?: components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.DataLimitationPolicy'];
    DataStructurePolicy?: components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.DataStructurePolicy'];
    DataFilteringPolicy?: components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.DataFilteringPolicy'][];
  } = {},
  requestConfig: RequestConfig | null = null,
): Promise<
  (components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.FullSubscription'] &
    components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.LimitedSubscription'] &
    components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.PartialSubscription'])[]
> =>
  get({
    url: `subscriptions/${identifier}/nameaddress${objectToQueryParams(queryParameters)}`,
    apiSegment: 'customers',
    requireAuth: true,
    ...(requestConfig || {}),
  });

/**
 * `/customers/subscriptions/{identifier}/nameaddress`: Gets all subscriptions associated to a name-address-id
 * @param identifier  No description
 * @param EnablePackageExpansion  No description
 * @param IncludeRootPackageWhenPackageExpansionIsEnabled  No description
 * @param EnableBackwardsCompatibility  No description
 * @param DataLimitationPolicy  No description
 * @param DataStructurePolicy  No description
 * @param DataFilteringPolicy  No description
 * @param requestConfig Any additional properties to be added to the request
 * @param queryConfig  Optional configuration object for React Query
 */
export const useSubscriptionsNameaddressByIdentifier = <
  TOut = (components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.FullSubscription'] &
    components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.LimitedSubscription'] &
    components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.PartialSubscription'])[],
>(
  identifier: string,
  queryParameters: {
    EnablePackageExpansion?: boolean;
    IncludeRootPackageWhenPackageExpansionIsEnabled?: boolean;
    EnableBackwardsCompatibility?: boolean;
    DataLimitationPolicy?: components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.DataLimitationPolicy'];
    DataStructurePolicy?: components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.DataStructurePolicy'];
    DataFilteringPolicy?: components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.DataFilteringPolicy'][];
  } = {},
  requestConfig: RequestConfig | null = null,
  queryConfig: UseQueryOptions<
    (components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.FullSubscription'] &
      components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.LimitedSubscription'] &
      components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.PartialSubscription'])[],
    AxiosError<any>,
    TOut,
    any[]
  > | null = null,
) =>
  useQuery(
    [
      '/customers/subscriptions/{identifier}/nameaddress',
      identity.userId,
      identifier,
      queryParameters,
    ],
    () => fetchSubscriptionsNameaddressByIdentifier(identifier, queryParameters, requestConfig),
    queryConfig || {},
  );

/**
 * `/customers/subscriptions/{identifier}/lid`: Gets all subscriptions associated to a lid.
 * @param identifier  No description
 * @param EnablePackageExpansion  No description
 * @param IncludeRootPackageWhenPackageExpansionIsEnabled  No description
 * @param EnableBackwardsCompatibility  No description
 * @param DataLimitationPolicy  No description
 * @param DataStructurePolicy  No description
 * @param DataFilteringPolicy  No description
 * @param requestConfig Any additional properties to be added to the request
 */
export const fetchSubscriptionsLidByIdentifier = (
  identifier: string,
  queryParameters: {
    EnablePackageExpansion?: boolean;
    IncludeRootPackageWhenPackageExpansionIsEnabled?: boolean;
    EnableBackwardsCompatibility?: boolean;
    DataLimitationPolicy?: components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.DataLimitationPolicy'];
    DataStructurePolicy?: components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.DataStructurePolicy'];
    DataFilteringPolicy?: components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.DataFilteringPolicy'][];
  } = {},
  requestConfig: RequestConfig | null = null,
): Promise<
  (components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.FullSubscription'] &
    components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.LimitedSubscription'] &
    components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.PartialSubscription'])[]
> =>
  get({
    url: `subscriptions/${identifier}/lid${objectToQueryParams(queryParameters)}`,
    apiSegment: 'customers',
    requireAuth: true,
    ...(requestConfig || {}),
  });

/**
 * `/customers/subscriptions/{identifier}/lid`: Gets all subscriptions associated to a lid.
 * @param identifier  No description
 * @param EnablePackageExpansion  No description
 * @param IncludeRootPackageWhenPackageExpansionIsEnabled  No description
 * @param EnableBackwardsCompatibility  No description
 * @param DataLimitationPolicy  No description
 * @param DataStructurePolicy  No description
 * @param DataFilteringPolicy  No description
 * @param requestConfig Any additional properties to be added to the request
 * @param queryConfig  Optional configuration object for React Query
 */
export const useSubscriptionsLidByIdentifier = <
  TOut = (components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.FullSubscription'] &
    components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.LimitedSubscription'] &
    components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.PartialSubscription'])[],
>(
  identifier: string,
  queryParameters: {
    EnablePackageExpansion?: boolean;
    IncludeRootPackageWhenPackageExpansionIsEnabled?: boolean;
    EnableBackwardsCompatibility?: boolean;
    DataLimitationPolicy?: components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.DataLimitationPolicy'];
    DataStructurePolicy?: components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.DataStructurePolicy'];
    DataFilteringPolicy?: components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.DataFilteringPolicy'][];
  } = {},
  requestConfig: RequestConfig | null = null,
  queryConfig: UseQueryOptions<
    (components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.FullSubscription'] &
      components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.LimitedSubscription'] &
      components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.PartialSubscription'])[],
    AxiosError<any>,
    TOut,
    any[]
  > | null = null,
) =>
  useQuery(
    ['/customers/subscriptions/{identifier}/lid', identity.userId, identifier, queryParameters],
    () => fetchSubscriptionsLidByIdentifier(identifier, queryParameters, requestConfig),
    queryConfig || {},
  );

/**
 * `/customers/subscriptions/{identifier}`: Gets subscription from a subscription query (subscriptionId:packageItemId)
 * Specific package products can be queried by adding the delimiter ':' and the packageItemId.
 * NOTE: Request limit is set to a maximum of 5 unique external customer identifiers.
 * A unique external customer identifier is either a name-address-id, linkit-id or lid.
 * Multiple subscriptions for the same external customer identifier still only counts as one in this limitation.
 *
 * Example 1: Get a subscription based on the subscriptionId
 * GET subscriptions/1
 *
 * Example 2: Get a subscription package item based on the subscriptionId and packageItemId
 * GET subscriptions/1:2
 * @param identifier  No description
 * @param EnablePackageExpansion  No description
 * @param IncludeRootPackageWhenPackageExpansionIsEnabled  No description
 * @param EnableBackwardsCompatibility  No description
 * @param DataLimitationPolicy  No description
 * @param DataStructurePolicy  No description
 * @param DataFilteringPolicy  No description
 * @param requestConfig Any additional properties to be added to the request
 */
export const fetchSubscriptionsByIdentifier = (
  identifier: string,
  queryParameters: {
    EnablePackageExpansion?: boolean;
    IncludeRootPackageWhenPackageExpansionIsEnabled?: boolean;
    EnableBackwardsCompatibility?: boolean;
    DataLimitationPolicy?: components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.DataLimitationPolicy'];
    DataStructurePolicy?: components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.DataStructurePolicy'];
    DataFilteringPolicy?: components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.DataFilteringPolicy'][];
  } = {},
  requestConfig: RequestConfig | null = null,
): Promise<
  (components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.FullSubscription'] &
    components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.LimitedSubscription'] &
    components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.PartialSubscription'])[]
> =>
  get({
    url: `subscriptions/${identifier}${objectToQueryParams(queryParameters)}`,
    apiSegment: 'customers',
    requireAuth: true,
    ...(requestConfig || {}),
  });

/**
 * `/customers/subscriptions/{identifier}`: Gets subscription from a subscription query (subscriptionId:packageItemId)
 * Specific package products can be queried by adding the delimiter ':' and the packageItemId.
 * NOTE: Request limit is set to a maximum of 5 unique external customer identifiers.
 * A unique external customer identifier is either a name-address-id, linkit-id or lid.
 * Multiple subscriptions for the same external customer identifier still only counts as one in this limitation.
 *
 * Example 1: Get a subscription based on the subscriptionId
 * GET subscriptions/1
 *
 * Example 2: Get a subscription package item based on the subscriptionId and packageItemId
 * GET subscriptions/1:2
 * @param identifier  No description
 * @param EnablePackageExpansion  No description
 * @param IncludeRootPackageWhenPackageExpansionIsEnabled  No description
 * @param EnableBackwardsCompatibility  No description
 * @param DataLimitationPolicy  No description
 * @param DataStructurePolicy  No description
 * @param DataFilteringPolicy  No description
 * @param requestConfig Any additional properties to be added to the request
 * @param queryConfig  Optional configuration object for React Query
 */
export const useSubscriptionsByIdentifier = <
  TOut = (components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.FullSubscription'] &
    components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.LimitedSubscription'] &
    components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.PartialSubscription'])[],
>(
  identifier: string,
  queryParameters: {
    EnablePackageExpansion?: boolean;
    IncludeRootPackageWhenPackageExpansionIsEnabled?: boolean;
    EnableBackwardsCompatibility?: boolean;
    DataLimitationPolicy?: components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.DataLimitationPolicy'];
    DataStructurePolicy?: components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.DataStructurePolicy'];
    DataFilteringPolicy?: components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.DataFilteringPolicy'][];
  } = {},
  requestConfig: RequestConfig | null = null,
  queryConfig: UseQueryOptions<
    (components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.FullSubscription'] &
      components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.LimitedSubscription'] &
      components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.PartialSubscription'])[],
    AxiosError<any>,
    TOut,
    any[]
  > | null = null,
) =>
  useQuery(
    ['/customers/subscriptions/{identifier}', identity.userId, identifier, queryParameters],
    () => fetchSubscriptionsByIdentifier(identifier, queryParameters, requestConfig),
    queryConfig || {},
  );

/**
 * `/customers/subscriptions`: Gets a list of subscriptions from a subscription query (subscriptionId:packageItemId)
 * Specific package products can be queried by adding the delimiter ':' and the packageItemId.
 * NOTE: Request limit is set to a maximum of 5 unique external customer identifiers.
 * A unique external customer identifier is either a name-address-id, linkit-id or lid.
 * Multiple subscriptions for the same external customer identifier still only counts as one in this limitation.
 * @param EnablePackageExpansion  No description
 * @param IncludeRootPackageWhenPackageExpansionIsEnabled  No description
 * @param EnableBackwardsCompatibility  No description
 * @param DataLimitationPolicy  No description
 * @param DataStructurePolicy  No description
 * @param DataFilteringPolicy  No description
 * @param requestConfig Any additional properties to be added to the request
 */
export const submitSubscriptions = (
  queryParameters: {
    EnablePackageExpansion?: boolean;
    IncludeRootPackageWhenPackageExpansionIsEnabled?: boolean;
    EnableBackwardsCompatibility?: boolean;
    DataLimitationPolicy?: components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.DataLimitationPolicy'];
    DataStructurePolicy?: components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.DataStructurePolicy'];
    DataFilteringPolicy?: components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.DataFilteringPolicy'][];
  } = {},
  data: string[],
  requestConfig: RequestConfig | null = null,
): Promise<
  (components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.FullSubscription'] &
    components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.LimitedSubscription'] &
    components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.PartialSubscription'])[]
> =>
  post({
    url: `subscriptions${objectToQueryParams(queryParameters)}`,
    apiSegment: 'customers',
    data,
    requireAuth: true,
    ...(requestConfig || {}),
  });

/**
 * `/customers/subscriptions/neighbors/{identifier}`: Gets all subscriptions which matches the lid
 * @param identifier  No description
 * @param EnablePackageExpansion  No description
 * @param IncludeRootPackageWhenPackageExpansionIsEnabled  No description
 * @param EnableBackwardsCompatibility  No description
 * @param DataLimitationPolicy  No description
 * @param DataStructurePolicy  No description
 * @param DataFilteringPolicy  No description
 * @param requestConfig Any additional properties to be added to the request
 */
export const fetchSubscriptionsNeighborsByIdentifier = (
  identifier: string,
  queryParameters: {
    EnablePackageExpansion?: boolean;
    IncludeRootPackageWhenPackageExpansionIsEnabled?: boolean;
    EnableBackwardsCompatibility?: boolean;
    DataLimitationPolicy?: components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.DataLimitationPolicy'];
    DataStructurePolicy?: components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.DataStructurePolicy'];
    DataFilteringPolicy?: components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.DataFilteringPolicy'][];
  } = {},
  requestConfig: RequestConfig | null = null,
): Promise<
  (components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.FullSubscription'] &
    components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.LimitedSubscription'] &
    components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.PartialSubscription'])[]
> =>
  get({
    url: `subscriptions/neighbors/${identifier}${objectToQueryParams(queryParameters)}`,
    apiSegment: 'customers',
    requireAuth: true,
    ...(requestConfig || {}),
  });

/**
 * `/customers/subscriptions/neighbors/{identifier}`: Gets all subscriptions which matches the lid
 * @param identifier  No description
 * @param EnablePackageExpansion  No description
 * @param IncludeRootPackageWhenPackageExpansionIsEnabled  No description
 * @param EnableBackwardsCompatibility  No description
 * @param DataLimitationPolicy  No description
 * @param DataStructurePolicy  No description
 * @param DataFilteringPolicy  No description
 * @param requestConfig Any additional properties to be added to the request
 * @param queryConfig  Optional configuration object for React Query
 */
export const useSubscriptionsNeighborsByIdentifier = <
  TOut = (components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.FullSubscription'] &
    components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.LimitedSubscription'] &
    components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.PartialSubscription'])[],
>(
  identifier: string,
  queryParameters: {
    EnablePackageExpansion?: boolean;
    IncludeRootPackageWhenPackageExpansionIsEnabled?: boolean;
    EnableBackwardsCompatibility?: boolean;
    DataLimitationPolicy?: components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.DataLimitationPolicy'];
    DataStructurePolicy?: components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.DataStructurePolicy'];
    DataFilteringPolicy?: components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.DataFilteringPolicy'][];
  } = {},
  requestConfig: RequestConfig | null = null,
  queryConfig: UseQueryOptions<
    (components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.FullSubscription'] &
      components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.LimitedSubscription'] &
      components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.PartialSubscription'])[],
    AxiosError<any>,
    TOut,
    any[]
  > | null = null,
) =>
  useQuery(
    [
      '/customers/subscriptions/neighbors/{identifier}',
      identity.userId,
      identifier,
      queryParameters,
    ],
    () => fetchSubscriptionsNeighborsByIdentifier(identifier, queryParameters, requestConfig),
    queryConfig || {},
  );

/**
 * `/customers/subscriptions/columbusproducts`: Gets the full Columbus product hierarchy for a specified subscription.
 * This will contain a limited version of the original Columbus product(s) including additional products.
 * NOTE: The Columbus product catalog used to fetch the hiearchy is "TGSP"
 * @param EnablePackageExpansion  No description
 * @param IncludeRootPackageWhenPackageExpansionIsEnabled  No description
 * @param EnableBackwardsCompatibility  No description
 * @param DataLimitationPolicy  No description
 * @param DataStructurePolicy  No description
 * @param DataFilteringPolicy  No description
 * @param requestConfig Any additional properties to be added to the request
 */
export const submitSubscriptionsColumbusproducts = (
  queryParameters: {
    EnablePackageExpansion?: boolean;
    IncludeRootPackageWhenPackageExpansionIsEnabled?: boolean;
    EnableBackwardsCompatibility?: boolean;
    DataLimitationPolicy?: components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.DataLimitationPolicy'];
    DataStructurePolicy?: components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.DataStructurePolicy'];
    DataFilteringPolicy?: components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.DataFilteringPolicy'][];
  } = {},
  data: string[],
  requestConfig: RequestConfig | null = null,
): Promise<
  components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.Columbus.LimitedColumbusProductSubscriptionReference'][]
> =>
  post({
    url: `subscriptions/columbusproducts${objectToQueryParams(queryParameters)}`,
    apiSegment: 'customers',
    data,
    requireAuth: true,
    ...(requestConfig || {}),
  });

/**
 * `/customers/subscriptions/{identifier}/terminated/madid`: Gets all terminated subscriptions by given MadId
 * @param identifier  No description
 * @param requestConfig Any additional properties to be added to the request
 */
export const fetchSubscriptionsTerminatedMadidByIdentifier = (
  identifier: string,
  requestConfig: RequestConfig | null = null,
): Promise<
  components['schemas']['Nuuday.NextGen.Customers.Contracts.Terminated.TerminatedSubscription'][]
> =>
  get({
    url: `subscriptions/${identifier}/terminated/madid`,
    apiSegment: 'customers',
    requireAuth: true,
    ...(requestConfig || {}),
  });

/**
 * `/customers/subscriptions/{identifier}/terminated/madid`: Gets all terminated subscriptions by given MadId
 * @param identifier  No description
 * @param requestConfig Any additional properties to be added to the request
 * @param queryConfig  Optional configuration object for React Query
 */
export const useSubscriptionsTerminatedMadidByIdentifier = <
  TOut = components['schemas']['Nuuday.NextGen.Customers.Contracts.Terminated.TerminatedSubscription'][],
>(
  identifier: string,
  requestConfig: RequestConfig | null = null,
  queryConfig: UseQueryOptions<
    components['schemas']['Nuuday.NextGen.Customers.Contracts.Terminated.TerminatedSubscription'][],
    AxiosError<any>,
    TOut,
    any[]
  > | null = null,
) =>
  useQuery(
    ['/customers/subscriptions/{identifier}/terminated/madid', identity.userId, identifier],
    () => fetchSubscriptionsTerminatedMadidByIdentifier(identifier, requestConfig),
    queryConfig || {},
  );

/**
 * `/customers/my/subscriptions/compare`: No summary available
 * @param requestConfig Any additional properties to be added to the request
 */
export const submitMySubscriptionsCompare = (
  data: components['schemas']['MitYouSee.Customers.Api.Comparer.Model.OdinSubscriptionLabel'][],
  requestConfig: RequestConfig | null = null,
): Promise<
  (components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.FullSubscription'] &
    components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.LimitedSubscription'] &
    components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.PartialSubscription'])[]
> =>
  post({
    url: `my/subscriptions/compare`,
    apiSegment: 'customers',
    data,
    requireAuth: true,
    ...(requestConfig || {}),
  });

/**
 * `/customers/subscriptions/addons`: Gets addons for each subscription in a one-dimensional data structure.
 * Note: Original hierarchical structure for addons will not be preserved as a part of this output.
 * @param EnablePackageExpansion  No description
 * @param DataLimitationPolicy  No description
 * @param DataFilteringPolicy  No description
 * @param requestConfig Any additional properties to be added to the request
 */
export const submitSubscriptionsAddons = (
  queryParameters: {
    EnablePackageExpansion?: boolean;
    DataLimitationPolicy?: components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.DataLimitationPolicy'];
    DataFilteringPolicy?: components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.DataFilteringPolicy'][];
  } = {},
  data: string[],
  requestConfig: RequestConfig | null = null,
): Promise<any> =>
  post({
    url: `subscriptions/addons${objectToQueryParams(queryParameters)}`,
    apiSegment: 'customers',
    data,
    requireAuth: true,
    ...(requestConfig || {}),
  });

/**
 * `/customers/subscriptions/{identifier}/orders`: Gets all orders associated to a supplied subcription identifier
 * @param identifier  No description
 * @param OrderStateType  No description
 * @param requestConfig Any additional properties to be added to the request
 */
export const fetchSubscriptionsOrdersByIdentifier = (
  identifier: string,
  OrderStateType:
    | components['schemas']['Nuuday.NextGen.Customers.Contracts.Orders.OrderStateType']
    | null = null,
  requestConfig: RequestConfig | null = null,
): Promise<
  components['schemas']['Nuuday.NextGen.Customers.Contracts.Orders.SubscriptionOrder'][]
> =>
  get({
    url: `subscriptions/${identifier}/orders${
      OrderStateType ? `?OrderStateType=${OrderStateType}` : ''
    }`,
    apiSegment: 'customers',
    requireAuth: true,
    ...(requestConfig || {}),
  });

/**
 * `/customers/subscriptions/{identifier}/orders`: Gets all orders associated to a supplied subcription identifier
 * @param identifier  No description
 * @param OrderStateType  No description
 * @param requestConfig Any additional properties to be added to the request
 * @param queryConfig  Optional configuration object for React Query
 */
export const useSubscriptionsOrdersByIdentifier = <
  TOut = components['schemas']['Nuuday.NextGen.Customers.Contracts.Orders.SubscriptionOrder'][],
>(
  identifier: string,
  OrderStateType:
    | components['schemas']['Nuuday.NextGen.Customers.Contracts.Orders.OrderStateType']
    | null = null,
  requestConfig: RequestConfig | null = null,
  queryConfig: UseQueryOptions<
    components['schemas']['Nuuday.NextGen.Customers.Contracts.Orders.SubscriptionOrder'][],
    AxiosError<any>,
    TOut,
    any[]
  > | null = null,
) =>
  useQuery(
    ['/customers/subscriptions/{identifier}/orders', identity.userId, identifier, OrderStateType],
    () => fetchSubscriptionsOrdersByIdentifier(identifier, OrderStateType, requestConfig),
    queryConfig || {},
  );

/**
 * `/customers/subscriptions/orders`: Gets all orders associated to supplied subcription ids
 * @param OrderStateType  No description
 * @param requestConfig Any additional properties to be added to the request
 */
export const submitSubscriptionsOrders = (
  OrderStateType:
    | components['schemas']['Nuuday.NextGen.Customers.Contracts.Orders.OrderStateType']
    | null = null,
  data: string[],
  requestConfig: RequestConfig | null = null,
): Promise<
  components['schemas']['Nuuday.NextGen.Customers.Contracts.Orders.SubscriptionOrder'][]
> =>
  post({
    url: `subscriptions/orders${OrderStateType ? `?OrderStateType=${OrderStateType}` : ''}`,
    apiSegment: 'customers',
    data,
    requireAuth: true,
    ...(requestConfig || {}),
  });

/**
 * `/customers/subscriptions/roles`: Get 'User', 'Payer' and 'Owner' customer information for a set of subscriptions.
 * @param RoleFilteringPolicy  No description
 * @param DataFilteringPolicy  No description
 * @param requestConfig Any additional properties to be added to the request
 */
export const submitSubscriptionsRoles = (
  queryParameters: {
    RoleFilteringPolicy?: components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.Roles.RoleFilteringPolicy'][];
    DataFilteringPolicy?: components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.DataFilteringPolicy'][];
  } = {},
  data: string[],
  requestConfig: RequestConfig | null = null,
): Promise<
  (components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.Roles.SubscriptionOwner'] &
    components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.Roles.SubscriptionPayer'] &
    components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.Roles.SubscriptionUser'])[]
> =>
  post({
    url: `subscriptions/roles${objectToQueryParams(queryParameters)}`,
    apiSegment: 'customers',
    data,
    requireAuth: true,
    ...(requestConfig || {}),
  });

/**
 * `/customers/transactions/{id}`: No summary available
 * @param id  No description
 * @param requestConfig Any additional properties to be added to the request
 */
export const fetchTransactionsById = (
  id: string,
  requestConfig: RequestConfig | null = null,
): Promise<
  components['schemas']['Nuuday.NextGen.Foundation.Transactions.DistributedTransaction']
> =>
  get({
    url: `transactions/${id}`,
    apiSegment: 'customers',
    requireAuth: true,
    ...(requestConfig || {}),
  });

/**
 * `/customers/transactions/{id}`: No summary available
 * @param id  No description
 * @param requestConfig Any additional properties to be added to the request
 * @param queryConfig  Optional configuration object for React Query
 */
export const useTransactionsById = <
  TOut = components['schemas']['Nuuday.NextGen.Foundation.Transactions.DistributedTransaction'],
>(
  id: string,
  requestConfig: RequestConfig | null = null,
  queryConfig: UseQueryOptions<
    components['schemas']['Nuuday.NextGen.Foundation.Transactions.DistributedTransaction'],
    AxiosError<any>,
    TOut,
    any[]
  > | null = null,
) =>
  useQuery(
    ['/customers/transactions/{id}', identity.userId, id],
    () => fetchTransactionsById(id, requestConfig),
    queryConfig || {},
  );

/**
 * `/customers/transactions`: No summary available
 * @param requestConfig Any additional properties to be added to the request
 */
export const submitTransactions = (
  data: string[],
  requestConfig: RequestConfig | null = null,
): Promise<
  components['schemas']['Nuuday.NextGen.Foundation.Transactions.DistributedTransaction'][]
> =>
  post({
    url: `transactions`,
    apiSegment: 'customers',
    data,
    requireAuth: true,
    ...(requestConfig || {}),
  });

/**
 * `/customers/version`: No summary available
 * @param requestConfig Any additional properties to be added to the request
 */
export const fetchVersion = (requestConfig: RequestConfig | null = null): Promise<any> =>
  get({
    url: `version`,
    apiSegment: 'customers',
    requireAuth: true,
    ...(requestConfig || {}),
  });

/**
 * `/customers/version`: No summary available
 * @param requestConfig Any additional properties to be added to the request
 * @param queryConfig  Optional configuration object for React Query
 */
export const useVersion = <TOut = any>(
  requestConfig: RequestConfig | null = null,
  queryConfig: UseQueryOptions<any, AxiosError<any>, TOut, any[]> | null = null,
) =>
  useQuery(
    ['/customers/version', identity.userId],
    () => fetchVersion(requestConfig),
    queryConfig || {},
  );

/**
 * `/customers/subscriptions/{identifier}/accountnumber`: Gets all subscriptions associated to an account-number.
 * @param identifier  No description
 * @param EnablePackageExpansion  No description
 * @param IncludeRootPackageWhenPackageExpansionIsEnabled  No description
 * @param EnableBackwardsCompatibility  No description
 * @param DataLimitationPolicy  No description
 * @param DataStructurePolicy  No description
 * @param DataFilteringPolicy  No description
 * @param requestConfig Any additional properties to be added to the request
 */
export const fetchSubscriptionsAccountnumberByIdentifier = (
  identifier: number,
  queryParameters: {
    EnablePackageExpansion?: boolean;
    IncludeRootPackageWhenPackageExpansionIsEnabled?: boolean;
    EnableBackwardsCompatibility?: boolean;
    DataLimitationPolicy?: components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.DataLimitationPolicy'];
    DataStructurePolicy?: components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.DataStructurePolicy'];
    DataFilteringPolicy?: components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.DataFilteringPolicy'][];
  } = {},
  requestConfig: RequestConfig | null = null,
): Promise<
  (components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.FullSubscription'] &
    components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.LimitedSubscription'] &
    components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.PartialSubscription'])[]
> =>
  get({
    url: `subscriptions/${identifier}/accountnumber${objectToQueryParams(queryParameters)}`,
    apiSegment: 'customers',
    requireAuth: true,
    ...(requestConfig || {}),
  });

/**
 * `/customers/subscriptions/{identifier}/accountnumber`: Gets all subscriptions associated to an account-number.
 * @param identifier  No description
 * @param EnablePackageExpansion  No description
 * @param IncludeRootPackageWhenPackageExpansionIsEnabled  No description
 * @param EnableBackwardsCompatibility  No description
 * @param DataLimitationPolicy  No description
 * @param DataStructurePolicy  No description
 * @param DataFilteringPolicy  No description
 * @param requestConfig Any additional properties to be added to the request
 * @param queryConfig  Optional configuration object for React Query
 */
export const useSubscriptionsAccountnumberByIdentifier = <
  TOut = (components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.FullSubscription'] &
    components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.LimitedSubscription'] &
    components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.PartialSubscription'])[],
>(
  identifier: number,
  queryParameters: {
    EnablePackageExpansion?: boolean;
    IncludeRootPackageWhenPackageExpansionIsEnabled?: boolean;
    EnableBackwardsCompatibility?: boolean;
    DataLimitationPolicy?: components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.DataLimitationPolicy'];
    DataStructurePolicy?: components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.DataStructurePolicy'];
    DataFilteringPolicy?: components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.DataFilteringPolicy'][];
  } = {},
  requestConfig: RequestConfig | null = null,
  queryConfig: UseQueryOptions<
    (components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.FullSubscription'] &
      components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.LimitedSubscription'] &
      components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.PartialSubscription'])[],
    AxiosError<any>,
    TOut,
    any[]
  > | null = null,
) =>
  useQuery(
    [
      '/customers/subscriptions/{identifier}/accountnumber',
      identity.userId,
      identifier,
      queryParameters,
    ],
    () => fetchSubscriptionsAccountnumberByIdentifier(identifier, queryParameters, requestConfig),
    queryConfig || {},
  );

/**
 * `/customers/subscriptions/{identifier}/madid`: Gets all subscriptions associated to a MadId.
 * @param identifier  No description
 * @param EnablePackageExpansion  No description
 * @param IncludeRootPackageWhenPackageExpansionIsEnabled  No description
 * @param EnableBackwardsCompatibility  No description
 * @param DataLimitationPolicy  No description
 * @param DataStructurePolicy  No description
 * @param DataFilteringPolicy  No description
 * @param requestConfig Any additional properties to be added to the request
 */
export const fetchSubscriptionsMadidByIdentifier = (
  identifier: string,
  queryParameters: {
    EnablePackageExpansion?: boolean;
    IncludeRootPackageWhenPackageExpansionIsEnabled?: boolean;
    EnableBackwardsCompatibility?: boolean;
    DataLimitationPolicy?: components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.DataLimitationPolicy'];
    DataStructurePolicy?: components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.DataStructurePolicy'];
    DataFilteringPolicy?: components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.DataFilteringPolicy'][];
  } = {},
  requestConfig: RequestConfig | null = null,
): Promise<
  (components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.FullSubscription'] &
    components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.LimitedSubscription'] &
    components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.PartialSubscription'])[]
> =>
  get({
    url: `subscriptions/${identifier}/madid${objectToQueryParams(queryParameters)}`,
    apiSegment: 'customers',
    requireAuth: true,
    ...(requestConfig || {}),
  });

/**
 * `/customers/subscriptions/{identifier}/madid`: Gets all subscriptions associated to a MadId.
 * @param identifier  No description
 * @param EnablePackageExpansion  No description
 * @param IncludeRootPackageWhenPackageExpansionIsEnabled  No description
 * @param EnableBackwardsCompatibility  No description
 * @param DataLimitationPolicy  No description
 * @param DataStructurePolicy  No description
 * @param DataFilteringPolicy  No description
 * @param requestConfig Any additional properties to be added to the request
 * @param queryConfig  Optional configuration object for React Query
 */
export const useSubscriptionsMadidByIdentifier = <
  TOut = (components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.FullSubscription'] &
    components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.LimitedSubscription'] &
    components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.PartialSubscription'])[],
>(
  identifier: string,
  queryParameters: {
    EnablePackageExpansion?: boolean;
    IncludeRootPackageWhenPackageExpansionIsEnabled?: boolean;
    EnableBackwardsCompatibility?: boolean;
    DataLimitationPolicy?: components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.DataLimitationPolicy'];
    DataStructurePolicy?: components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.DataStructurePolicy'];
    DataFilteringPolicy?: components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.DataFilteringPolicy'][];
  } = {},
  requestConfig: RequestConfig | null = null,
  queryConfig: UseQueryOptions<
    (components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.FullSubscription'] &
      components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.LimitedSubscription'] &
      components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.PartialSubscription'])[],
    AxiosError<any>,
    TOut,
    any[]
  > | null = null,
) =>
  useQuery(
    ['/customers/subscriptions/{identifier}/madid', identity.userId, identifier, queryParameters],
    () => fetchSubscriptionsMadidByIdentifier(identifier, queryParameters, requestConfig),
    queryConfig || {},
  );

/**
 * `/customers/subscriptions/{identifier}/installationsequencenumber`: Gets installation sequence number by given subscription Identifier and subscription query options
 * @param identifier  No description
 * @param EnablePackageExpansion  No description
 * @param IncludeRootPackageWhenPackageExpansionIsEnabled  No description
 * @param EnableBackwardsCompatibility  No description
 * @param DataLimitationPolicy  No description
 * @param DataStructurePolicy  No description
 * @param DataFilteringPolicy  No description
 * @param requestConfig Any additional properties to be added to the request
 */
export const fetchSubscriptionsInstallationsequencenumberByIdentifier = (
  identifier: string,
  queryParameters: {
    EnablePackageExpansion?: boolean;
    IncludeRootPackageWhenPackageExpansionIsEnabled?: boolean;
    EnableBackwardsCompatibility?: boolean;
    DataLimitationPolicy?: components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.DataLimitationPolicy'];
    DataStructurePolicy?: components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.DataStructurePolicy'];
    DataFilteringPolicy?: components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.DataFilteringPolicy'][];
  } = {},
  requestConfig: RequestConfig | null = null,
): Promise<
  components['schemas']['Nuuday.NextGen.Customers.Contracts.InstallationSequenceNumberInfo']
> =>
  get({
    url: `subscriptions/${identifier}/installationsequencenumber${objectToQueryParams(
      queryParameters,
    )}`,
    apiSegment: 'customers',
    requireAuth: true,
    ...(requestConfig || {}),
  });

/**
 * `/customers/subscriptions/{identifier}/installationsequencenumber`: Gets installation sequence number by given subscription Identifier and subscription query options
 * @param identifier  No description
 * @param EnablePackageExpansion  No description
 * @param IncludeRootPackageWhenPackageExpansionIsEnabled  No description
 * @param EnableBackwardsCompatibility  No description
 * @param DataLimitationPolicy  No description
 * @param DataStructurePolicy  No description
 * @param DataFilteringPolicy  No description
 * @param requestConfig Any additional properties to be added to the request
 * @param queryConfig  Optional configuration object for React Query
 */
export const useSubscriptionsInstallationsequencenumberByIdentifier = <
  TOut = components['schemas']['Nuuday.NextGen.Customers.Contracts.InstallationSequenceNumberInfo'],
>(
  identifier: string,
  queryParameters: {
    EnablePackageExpansion?: boolean;
    IncludeRootPackageWhenPackageExpansionIsEnabled?: boolean;
    EnableBackwardsCompatibility?: boolean;
    DataLimitationPolicy?: components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.DataLimitationPolicy'];
    DataStructurePolicy?: components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.DataStructurePolicy'];
    DataFilteringPolicy?: components['schemas']['Nuuday.NextGen.Customers.Contracts.Subscriptions.DataFilteringPolicy'][];
  } = {},
  requestConfig: RequestConfig | null = null,
  queryConfig: UseQueryOptions<
    components['schemas']['Nuuday.NextGen.Customers.Contracts.InstallationSequenceNumberInfo'],
    AxiosError<any>,
    TOut,
    any[]
  > | null = null,
) =>
  useQuery(
    [
      '/customers/subscriptions/{identifier}/installationsequencenumber',
      identity.userId,
      identifier,
      queryParameters,
    ],
    () =>
      fetchSubscriptionsInstallationsequencenumberByIdentifier(
        identifier,
        queryParameters,
        requestConfig,
      ),
    queryConfig || {},
  );
